import { produce } from 'immer';
import { AUTH_LOGOUT } from '../actions';
import {
  DOCUMENT_EXPERT_DETAILS_GET,
  DOCUMENT_EXPERT_DETAILS_RESET,
  DOCUMENT_EXPERT_GET_COMMENTS,
  DOCUMENTS_EXPERT_CATEGORIES_GET,
  DOCUMENTS_EXPERT_DOCUMENT_CREATE,
  DOCUMENTS_EXPERT_LIST_GET,
} from '../actions/documentsExpert';

const initialState = {
  filters: {},
  list: [],
  details: {},
  pager: {},
  categories: [],
  categoriesAll: [],
  comments: {
    allow_reply: false,
    items: [],
  },
  newDocumentId: null,
};

const userReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      case DOCUMENTS_EXPERT_LIST_GET._SUCCESS: {
        const { response, pager } = action;
        draft.filters = { ...state.filters, ...(response?.filters || {}) };
        draft.list = response?.items || [];
        draft.pager = pager ?? {};
        break;
      }

      case DOCUMENT_EXPERT_DETAILS_GET._SUCCESS: {
        const { response = {} } = action;
        draft.details = { ...response };
        break;
      }

      case DOCUMENTS_EXPERT_CATEGORIES_GET._SUCCESS: {
        const { response = [], show_all } = action;
        if (show_all) draft.categoriesAll = response;
        else draft.categories = response;
        break;
      }

      case DOCUMENTS_EXPERT_DOCUMENT_CREATE._SUCCESS: {
        draft.newDocumentId = action?.response?.id || null;
        break;
      }

      case DOCUMENT_EXPERT_DETAILS_RESET: {
        draft.details = initialState.details;
        break;
      }

      case DOCUMENT_EXPERT_GET_COMMENTS._SUCCESS: {
        const { allow_reply = false, items = [] } = action?.data || {};
        draft.comments.allow_reply = allow_reply || false;
        draft.comments.items = [...(items || [])].reverse();
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default userReducer;
